import "./tournament-message-sent-success.scss";
import { useEffect } from "react";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearNotifications,
  getMessage,
  selectCurrentMessage,
  selectMessagesNotifications,
} from "../../../reducers/messagesSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNotificationBanner } from "../../../hooks/notificationHooks";
import { successForm } from "../../../forms/SuccessForm";
import TournamentMessageCard from "./tournament-message-card";

const TournamentMessageSentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const match = useMatch("/:tournamentID/messages/:messageID/sent-success");

  const currentMessage = useSelector(selectCurrentMessage);
  const notifications = useSelector(selectMessagesNotifications);

  useEffect(() => {
    dispatch(
      getMessage({
        tournamentID: match?.params?.tournamentID,
        messageID: match?.params?.messageID,
      }),
    );
  }, [dispatch, match?.params?.tournamentID, match?.params?.messageID]);

  const goToMessages = () => {
    dispatch(clearNotifications());
    navigate(`/${match?.params?.tournamentID}/messages`);
  };

  const getNavigation = () => {
    return {
      title: "Message Sent",
      leftIcon: faChevronLeft,
      leftButtonClick: goToMessages,
    };
  };

  const getFormTitle = () => {
    return (
      <div className="success-header">
        <div className="icon">
          <FontAwesomeIcon icon={faPaperPlane} />
        </div>
        Message Sent
      </div>
    );
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getFormTitle()}
        formSections={successForm(
          "Message",
          <TournamentMessageCard {...currentMessage} />,
          undefined,
          "This message has been sent!",
        )}
      />
    );
  };

  const getDrawerActions = () => {
    return [
      {
        name: "Done",
        action: goToMessages,
        type: "light-grey",
      },
    ];
  };

  const getDrawer = () => {
    return { actions: getDrawerActions() };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    <tournament-message-sent-success>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      />
    </tournament-message-sent-success>
  );
};

export default TournamentMessageSentSuccess;
